import { Divider, Grid, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import { LuPencil } from 'react-icons/lu';
import { ICandidate } from 'wisestep-api';
import {
  getDateUsingFormat,
  ScrollableTabs,
  TabTextVariant,
  WsButton,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { getSubmissionNotesActivities } from '../../../../../features/candidateLayout/utils/CandidateHelper';
import Empty_notes_image from '../../../../../images/Empty_Submission_Notes.svg';
import Empty_Submission_email_image from '../../../../../images/Submission_ Empty_Email.svg';
import { EmptyResponseCard, NoteActivity } from '../../childComponets';

import AddNoteDialog from './AddNoteDialog';

const SubmissionNotesAndEmail = ({ submission }: { submission: ICandidate }) => {
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [loadNextBatchIndex, setLoadNextBatchIndex] = useState<number>(0);
  const [openNoteDialog, setOpenNoteDialog] = useState<boolean>(false);
  const selectedTabIndex = (index: number) => setTabIndex(index);
  const noteActivities = getSubmissionNotesActivities(submission).sort((noteA, noteB) =>
    noteB.timestamp.localeCompare(noteA.timestamp)
  );
  const toggleNoteDialog = () => setOpenNoteDialog((prev) => !prev);
  return (
    <>
      <ScrollableTabs
        scrollList={[
          {
            tabName: 'Notes',
          },
          {
            tabName: 'Submission Email',
          },
        ]}
        getTabIndex={selectedTabIndex}
        variant={TabTextVariant.SUB_TITLE}
        defaultValue={tabIndex}
      />
      <Grid p={2}>
        {tabIndex == 0 && (
          <>
            <Grid display="flex" direction="column" rowGap={1}>
              <Grid display="flex" justifyContent="space-between" alignItems="center">
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                >{`Notes (${noteActivities.length})`}</WsTypography>
                <WsButton startIcon={<LuPencil />} size="small" onClick={toggleNoteDialog}>
                  Add Note
                </WsButton>
              </Grid>
              <Grid container direction="column" rowGap={1}>
                {noteActivities.length == 0 && (
                  <EmptyResponseCard
                    src={Empty_notes_image}
                    subText="Notes not available"
                    text=""
                  />
                )}

                {noteActivities.slice(0, (loadNextBatchIndex + 1) * 5).map((activity, index) => (
                  <Fragment key={index}>
                    <NoteActivity key={index} {...activity} />
                    <Divider />
                  </Fragment>
                ))}
              </Grid>
              <Grid textAlign="center">
                {noteActivities.length > (loadNextBatchIndex + 1) * 5 && (
                  <WsButton
                    variant="outlined"
                    onClick={() => setLoadNextBatchIndex((prev) => prev + 1)}
                  >
                    Load More
                  </WsButton>
                )}
              </Grid>
            </Grid>
            <AddNoteDialog
              submission={submission}
              openDialog={openNoteDialog}
              handleCloseDialog={toggleNoteDialog}
            />
          </>
        )}
        {tabIndex == 1 && (
          <Grid sx={{ overflowX: 'auto', overflowY: 'none' }}>
            <Grid alignItems="center">
              <WsTypography variant={WsTypoVariants.SUB_TITLE}>Submission Email</WsTypography>
              {submission?.modifiedOn && submission?.submissionEmailBody && (
                <WsTypography variant={WsTypoVariants.BODY2} opacity={true}>
                  {`Last Updated on ${getDateUsingFormat(
                    submission?.modifiedOn.toString(),
                    'MMM D, YYYY, h:mm A'
                  )}`}
                </WsTypography>
              )}
            </Grid>

            {!submission?.submissionEmailBody ? (
              <EmptyResponseCard
                src={Empty_Submission_email_image}
                subText="Submisson email not available"
                text=""
              />
            ) : (
              <Typography
                fontWeight={500}
                dangerouslySetInnerHTML={{
                  __html: submission?.submissionEmailBody ?? '',
                }}
                sx={{ pl: 2 }}
              />
            )}
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SubmissionNotesAndEmail;
